import { yupNumber, yupObject, yupPeriodicValue, yupString } from '../../yup';
import type { ExpenseTypeDto } from '@/api/backend/public';
import { getErhlExpenseDescription } from '@/helpers/erhlExpenseDescription';
import type { ObjectShape } from 'yup';

/**
 * Builds an ERHL-specific expenses validation schema.
 * Extends the standard V2 expenses schema with optional "after retirement"
 */
export const erhlExpensesSchemaV2 = (expenseTypes: ExpenseTypeDto[]) => {
  const yupConfiguration: ObjectShape = {
    numberOfDependants: yupNumber()
      .integer('Number of dependants must be a whole number')
      .min(0, 'Number of dependants cannot be negative')
      .required()
      .label('Number of dependants'),
    expenseChange: yupString().required('You must select an option'),
    expenseChangeAmount: yupPeriodicValue(yupNumber().required())
      .when('expenseChange', { is: (val: string) => val !== 'noChange', then: (schema) => schema.required() })
      .label('Change in living expenses'),
    expenseChangeReason: yupString()
      .when('expenseChange', { is: (val: string) => val !== 'noChange', then: (schema) => schema.required() })
      .label('Description of expense change effect'),
  };

  for (const expenseType of expenseTypes) {
    yupConfiguration[expenseType.type || ''] = yupPeriodicValue(yupNumber().required())
      .required()
      .label(getErhlExpenseDescription(expenseType.type || '').shortFormTitle || expenseType.type || '');
  }

  return yupObject(yupConfiguration);
};
